import { createCrudApi } from '@/libs/api/crud'
import { UpcomingCallResponse } from './types'

// IMPROVEME(MET-3053) - refactor with legacy to reduce duplication
export const UPCOMING_CALLS_ENDPOINT = '/api/communications/planned_calls'

export const upcomingCallsApi = createCrudApi<
  UpcomingCallResponse,
  'communicationId'
>(UPCOMING_CALLS_ENDPOINT)
